import React from 'react';
import styles from './ChartCard.module.scss';

interface ChartCardProps {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}

const ChartCard: React.FC<ChartCardProps> = ({ title, subtitle, action, children }) => {
  return (
    <section className={styles.card}>
      <header className={styles.header}>
        <div className={styles.headingText}>
          <h3 className={styles.title}>{title}</h3>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {action && <div className={styles.action}>{action}</div>}
      </header>
      <div className={styles.plot}>{children}</div>
    </section>
  );
};

export default ChartCard;
